export default [
  'home',
  'thornhill',
  'about us',
  'store',
  'lessons',
  'for students',
  'for teachers',
  // 'blog',
  'contact'
];


// WEBPACK FOOTER //
// ./src/components/Header/MenuBar/routes.js